/**
 * Layout component 
 */

import React from "react"
import PropTypes from "prop-types"

import WorkforceHeader from "../workforceheader"
import Footer from "../footer"
import WorkforceSEO from "../workforceseo"

import styles from "./workforcelayout.module.css"
/*import "./itmodlayout.css"*/

const Layout = ({ children }) => {

  return (
    <>
      <WorkforceSEO title="Home" />
      <WorkforceHeader />
      <div className={`container ${styles.container}`}>
        <main>{children}</main>
        <Footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout